import { useState, useEffect } from "react";

export default function PointsField({ data, onChange }) {
  const [points, setPoints] = useState(data?.rewardPoint || []);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setPoints(data?.rewardPoint || []);
  }, [data]);

  const handleAdd = () => {
    const num = parseInt(inputValue);
    if (!isNaN(num) && !points.includes(num)) {
      const updated = [...points, num];
      setPoints(updated);
      onChange?.(updated);
      setInputValue("");
    }
  };

  const handleRemove = (num) => {
    const updated = points.filter((p) => p !== num);
    setPoints(updated);
    onChange?.(updated);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAdd();
    }
  };

  return (
    <div className="w-full">
      {/* Tags */}
      <div className="flex flex-wrap gap-2 mb-2">
        {points.map((p) => (
          <div
            key={p}
            className="flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm"
          >
            {p}
            <button
              type="button"
              onClick={() => handleRemove(p)}
              className="ml-2 text-blue-600 hover:text-red-500 focus:outline-none"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="flex gap-2">
        <input
          type="number"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Add point"
          className="flex-1 p-2 border border-gray-300 rounded-lg"
        />
        <button
          type="button"
          onClick={handleAdd}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
        >
          Add
        </button>
      </div>
    </div>
  );
}
